export default __webpack_public_path__ + "161bd1f1b99982197aac2553c406381a.png";